import { createEventSender, Environment } from '@spotify-internal/event-sender';
import { getAuthTransport } from '../../transport';
import {
  createUserAgentContext,
  createCorrelationIdContext,
} from '@spotify-internal/event-sender/es5/contexts';
import { getCookie } from '../../cookie-utils';

export async function getEventSender() {
  /**
   * ensure transport is always connected and authenticated
   * before making requests via event sender.
   */
  const transport = await getAuthTransport();
  return createEventSender<Environment.BROWSER | Environment.BROWSER_NON_AUTH>({
    transport,
    context: [
      createCorrelationIdContext(getCookie('sp_t') ?? 'unknown'),
      createUserAgentContext(navigator?.userAgent ?? 'unknown'),
    ],
  });
}
